import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { MplTrans } from '@mopla/i18';

import { MplButton } from '../../atoms/MplButton/MplButton';
import { ArrowRightIcon } from '../../icons/ArrowRight';
import { MplModal } from '../MplModal/MplModal';

import { Description } from './EmailSentWarningMessage.styles';

interface IProps {
	open: boolean;
	onClose: VoidFunction;
	email?: string | null;
}

/** TODO redesign */
export const EmailSentWarningMessage: FC<IProps> = ({
	open,
	onClose,
	email = '',
}) => {
	const { t } = useTranslation('registration');

	return (
		<MplModal
			open={open}
			testId="EmailSentWarningMessage-MplModal"
			onBackDropClick={onClose}
			title={t('resendVerify.text.warning_title')}
			content={
				<Stack width="100%" gap={3}>
					<Typography variant="body1">
						<MplTrans
							i18nKey="registration:resendVerify.text.warning_text_start"
							values={{ regEmail: email }}
							components={{ bold: <b /> }}
						/>{' '}
						{t('resendVerify.text.warning_text_end')}
					</Typography>
					<Description marginBottom="16px">
						{t('resendVerify.text.warning_description')}
					</Description>
				</Stack>
			}
			buttons={
				<MplButton
					data-testid="registrationForm-verify-email-warning-modal-submit-button"
					endIcon={<ArrowRightIcon />}
					onClick={onClose}
					type="button"
					fullWidth
				>
					{t('resendVerify.text.warning_button')}
				</MplButton>
			}
		/>
	);
};
